export class OffsetCollection<T> extends Array<T> {
	totalCount: number;
	constructor(totalCount: number) {
		super();
		this.totalCount = totalCount;
	}
}
